module.exports = __webpack_public_path__ + "img/21_105.064a9de0.png";